import React, { Component } from 'react'

import Tabs from '../../../components/Tabs/'

import General from './tabs/general'
import Sessions from './tabs/sessions'
import Payment from './tabs/payment'
import Tutors from './tabs/tutors'

class RequestDetails extends Component {

  render() {

    if (!this.props.uuid) return null
  
    return <React.Fragment>

      <Tabs
        tabs={[{
          name: 'General',
          content: <General uuid={this.props.uuid} />
        },{
          name: 'Sessions',
          content: <Sessions uuid={this.props.uuid} />
        },{
          name: 'Tutors',
          content: <Tutors uuid={this.props.uuid} />
        },{
          name: 'Paiments',
          content: <Payment uuid={this.props.uuid} />
        }]} />

      </React.Fragment>

  }
}

export default RequestDetails;



// WEBPACK FOOTER //
// ./src/containers/requests/Details/index.js